import {dynamic} from '@github-ui/dynamic'
// eslint-disable-next-line @github-ui/github-monorepo/restrict-relay-imports -- Only declares lazy secondary components; does not load the viewer.
import {preheatIssueViewerSecondaryComponents} from '@github-ui/issue-viewer/preload-components'
import {withLazyAppBoundary} from '@github-ui/react-core/lazy-app-boundary'

export const IssueViewer = withLazyAppBoundary(
  dynamic(
    async () => {
      const module = await import('./IssueViewer')
      return {default: module.IssueViewer}
    },
    {displayName: 'IssueViewer'},
  ),
)

export async function preloadIssueViewer() {
  await Promise.all([IssueViewer.preload?.(), preheatIssueViewerSecondaryComponents()])
}
